const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeepColour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.6 22.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8,15c0-3.3-2.7-6-6-6s-6,2.7-6,6h12,0Z",
    style: {
      fill: "#4e7698"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1,12.6c.2,0,.3.1.3.3-.1,5.7-4.8,10.3-10.6,10.3S-.6,18.6-.8,12.9c0-.2.1-.3.3-.3,0,0,20.6,0,20.6,0Z",
    style: {
      fill: "#27455e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.2-.9h19.1c.1,0,.3.1.3.3v5.3c0,2.4-1.9,4.3-4.3,4.3H4.2C1.9,9,0,7.1,0,4.7V-.6C0-.7,0-.9.2-.9c0,0,0,0,0,0Z",
    style: {
      fill: "#1e374b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1,6.7c1.6,0,3-1.3,3-3S7.7.8,6.1.8s-3,1.3-3,3,1.3,3,3,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,6.7c1.6,0,3-1.3,3-3s-1.3-3-3-3-3,1.3-3,3,1.3,3,3,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1,5.3c.9,0,1.5-.7,1.5-1.6s-.7-1.6-1.5-1.6-1.6.7-1.6,1.6.7,1.6,1.6,1.6Z",
    style: {
      fill: "#1e374b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,5.3c.9,0,1.5-.7,1.5-1.6s-.7-1.6-1.5-1.6-1.5.7-1.5,1.6.7,1.6,1.5,1.6Z",
    style: {
      fill: "#1e374b"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3,14.7c0-3-2.5-5.5-5.5-5.5s-5.5,2.5-5.5,5.5h11Z",
    style: {
      fill: "#2d1432"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3,12.5c.1,0,.3.1.3.3-.1,5.2-4.4,9.5-9.7,9.5S.2,18,0,12.7c0-.1.1-.3.3-.3,0,0,18.9,0,18.9,0Z",
    style: {
      fill: "#20374c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.9,0h17.7c.1,0,.3.1.3.3v4.9c0,2.2-1.8,4-4,4H4.6c-2.2,0-4-1.8-4-4V.3c0-.1.1-.3.3-.3Z",
    style: {
      fill: "#143223"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.4,
    cy: 4.3,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.2,
    cy: 4.3,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.4,
    cy: 4.3,
    r: 1.4,
    style: {
      fill: "#143223"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.2,
    cy: 4.3,
    r: 1.4,
    style: {
      fill: "#143223"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeepColour);
export default __webpack_public_path__ + "static/media/Beep-colour.4f4c7d74b1ab0954a0011f1e0c0ca768.svg";
export { ForwardRef as ReactComponent };